import type { DirectusSalesLead } from '@/types/directus-types'
import { directusCreateOne, directusReadByQuery, directusUpdateOne } from './helperFunctions'

export async function fetchSalesLeads(): Promise<DirectusSalesLead[] | undefined> {
  const collection = 'sales_leads'
  const query = {
    limit: -1,
    fields: ['*.*', 'user.Driver.*', 'recommended_vehicles.Car_Record_id.*'],
  }

  const res = await directusReadByQuery<DirectusSalesLead>({ collection, query })
  return res
}

export async function updateSalesLead(
  id: string | number,
  item: Partial<DirectusSalesLead>,
): Promise<DirectusSalesLead | undefined> {
  const collection = 'sales_leads'
  const res = await directusUpdateOne<DirectusSalesLead>({ collection, id, item })
  return res
}

export async function createSalesLead(
  item: Partial<DirectusSalesLead>,
): Promise<{ success: boolean; data: DirectusSalesLead | undefined }> {
  const collection = 'sales_leads'
  const res = await directusCreateOne<DirectusSalesLead>({ collection, item })
  return res
}
